const IMAGE_EXT_REGEX = /\.(jpe?g|png|gif|webp|heic|heif|avif|bmp|tiff?)$/i;

export const getFileNameFromUri = (
  uri?: string,
): string | undefined => {
  if (!uri) {
    return undefined;
  }

  const cleanedUri = uri.split('?')[0];
  return cleanedUri.split('/').pop() ?? undefined;
};

export const isImageFile = (
  fileUri?: string,
  fileType?: string,
  fileName?: string,
): boolean => {
  if (fileType?.startsWith('image/')) {
    return true;
  }

  const target = fileName ?? fileUri;
  if (!target) {
    return false;
  }

  return IMAGE_EXT_REGEX.test(target);
};
